import { render, staticRenderFns } from "./CImageUploadRow.vue?vue&type=template&id=20518a3b&scoped=true"
import script from "./CImageUploadRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CImageUploadRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CImageUploadRow.vue?vue&type=style&index=0&id=20518a3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20518a3b",
  null
  
)

export default component.exports